import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AdminServiceConfig } from './admin-service.types';

export function provideAdminService(config: AdminServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'adminServiceConfig', useValue: config }
  ]);
}
